import carousel from './carousel';

const pressSwiper = document.querySelector('[data-id="press-swiper"]');
carousel(pressSwiper, { loop: false });
